<template>
    <div>
        <tab name="1">{{data && data.name}}(ID:{{id}})</tab>
        <user-baseinfo :dataVo="data" v-loading="dataLoading"></user-baseinfo>
    </div>
</template>

<script>
import Tab from './components/tab';
import userBaseinfo from '@/views/user/components/user-baseinfo';
export default {
    props:{
        id:{
            type:[Number,String],
            default: ''
        }
    },
    components:{
        Tab,userBaseinfo
    },
    data() {
        return {
            data:null,
            dataLoading:false
        };
    },
    mounted(){
        this.getData();
    },
    methods: {
        // 获取详细数据
        getData(){
            this.dataLoading = true;
            this.$request({
                url: "/brand/detail",
                data: { id: parseInt(this.id) },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result;
                    }else{
                       this.$message.error(msg || "获取信息失败,请重试"); 
                    }
                })
                .catch(() => {
                    this.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        }
    },
};
</script>
